package app.smartcoding.realrate.localization

import cafe.adriel.lyricist.LyricistStrings

@LyricistStrings(languageTag = "ur")
val UrStrings = Strings(
    analyzer = "تجزیہ کار",
    appreciationOverview = "قدر میں اضافے کا جائزہ",
    chartLegendInterest = "سود",
    chartLegendPrincipal = "اصل زر",
    chartXaxisMonths = "مہینے",
    chartYaxisPayment = "ادائیگی",
    code = "ur",
    costOfCredit = "کریڈٹ کی لاگت",
    creditDealAnalyzerDescription = "اپنی کریڈٹ ڈیل کا جامع تجزیہ حاصل کرنے کے لیے اپنے قرض کی تفصیلات درج کریں۔ ہمارا تجزیہ کار آپ کو اپنے قرض کی اصل لاگت کو سمجھنے اور باخبر فیصلہ کرنے میں مدد کرنے کے لیے کلیدی میٹرکس کا جائزہ لیتا ہے۔",
    detailsGoodRateLongTerm = "اچھا ریٹ لیکن لمبی مدت کے نتیجے میں کل لاگت زیادہ ہوتی ہے۔",
    detailsHighApr = "زیادہ اے پی آر۔ ",
    detailsHighInterestCost = "زیادہ کل سود کی لاگت۔",
    detailsHighRateShortTerm = "زیادہ ریٹ لیکن مختصر مدت کل لاگت کو کم رکھتی ہے۔",
    detailsLowApr = "کم اے پی آر۔ ",
    detailsLowInterestCost = "کم کل سود کی لاگت۔",
    discountsTradeIn = "رعایت / ٹریڈ ان",
    displayName = "اردو",
    distribution = "تقسیم",
    downPayment = "ڈاؤن پیمنٹ",
    effectiveApr = "اے پی آر",
    headerBalance = "بیلنس",
    headerDate = "تاریخ",
    headerInterest = "سود",
    headerMonth = "#",
    headerPayment = "ادائیگی",
    headerPrincipal = "اصل زر",
    hideDetails = "تفصیلات چھپائیں",
    interest = "سود",
    invalidData = "غلط ڈیٹا",
    loanAmountSupportingText = "کل قرض کی رقم، بشمول کوئی اضافی اخراجات۔",
    loanDetails = "قرض کی تفصیلات",
    paymentSupportingText = "آپ کی متوقع ماہانہ ادائیگی।",
    paymentComposition = "ادائیگی کی ساخت",
    percentSymbol = "%",
    principal = "اصل زر",
    ratingBad = "برا سودا",
    ratingExcellent = "بہترین سودا",
    ratingFair = "مناسب سودا",
    ratingGood = "اچھا سودا",
    ratingPoor = "ناقص سودا",
    schedule = "شیڈول",
    showDetails = "تفصیلات دکھائیں",
    summaryBad = "بہت ناموافق، اگر ممکن ہو تو بچیں۔",
    summaryExcellent = "بہترین مالی حالات।",
    summaryFair = "مناسب حالات، بات چیت کرنے پر غور کریں۔",
    summaryGood = "اچھے حالات، مارکیٹ کے لیے معیاری।",
    summaryPoor = "ناقص حالات، زیادہ لاگت یا ریٹ।",
    totalPaid = "کل ادا شدہ",
    lockTaxRate = "ٹیکس ریٹ لاک کریں",
    unlockTaxRate = "ٹیکس ریٹ ان لاک کریں",
    currencySymbol = "₨",
    currency = "کرنسی",
    totalCreditAmount = "کریڈٹ کی کل رقم",
    taxAmount = "ٹیکس/کٹوتی کی رقم",
    netAmountDisbursed = "خالص تقسیم شدہ رقم",
    years = "سال",
    loanTermTotalMonths = "قرض کی مدت (مہینے)",
    monthlyInstallment = "ماہانہ قسط",
    principalInstallment = "اصل زر کی قسط",
    otherFees = "دیگر فیسیں",
    insuranceCost = "انشورنس پریمیم",
    aprc = "سالانہ فیصد شرح چارج (APRC)",
    totalAmountPayable = "کل قابل ادائیگی رقم",
    prepaidFeeFixed = "پروسیسنگ فیس (مقررہ رقم)",
    prepaidFeePercentage = "پروسیسنگ فیس (فیصد)",
    months = "مہینے",
    description = "یہ تجزیہ کار آپ کو یہ اندازہ لگانے میں مدد کرتا ہے کہ آیا قرض کی پیشکش آپ کے لیے سازگار ہے۔ معیاری کیلکولیٹر کے برعکس، اس میں سود کی شرح کے ان پٹ کی ضرورت نہیں ہوتی ہے۔ اس کے بجائے، یہ ادائیگیوں اور فیسوں کی بنیاد پر اے پی آر اور کریڈٹ کی کل لاگت का हिसाब लगाता है, जो एक ڈیل کی درجہ بندی اور تفصیلی چارٹ فراہم کرتا ہے۔",
    agree = "متفق",
    information = "معلومات",
    errorCalculationOverflow = "APR بہت زیادہ ہے، حساب کتاب کا بہاؤ۔",
    errorTotalPaymentIsLessThanLoanAmount = "موصولہ رقم قرض کی رقم سے کم ہے۔",
    errorDivisionByZero = "صفر سے تقسیم",
    errorNegativeResult = "منفی نتیجہ",
    errorRateTooHigh = "شرح بہت زیادہ ہے",
    errorCalculation = "برائے مہربانی درست ڈیٹا درج کریں",
    close = "بند کریں",

    hi = "ہیلو",
    guest = "مہمان",
    account = "اکاؤنٹ",
    signInWithGoogle = "Google کے ساتھ سائن ان کریں",
    signOut = "سائن آؤٹ",
    settings = "ترتیبات",
    about = "کے بارے में",
    privacyPolicy = "رازداری کی پالیسی",
    termsOfService = "سروس کی شرائط",
    language = "زبان",

    theme = "تھیم",
    light = "لائٹ",
    dark = "ڈارک",
    system = "سسٹم",
    toggleExpand = "پھیلائیں/سیکیڑیں",
)
